// extracted by mini-css-extract-plugin
export var title = "search-criterias-module--title--e5adf";